<template>
  <div class="refund-order-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input v-model="searchParams.prodNameLike" :placeholder="$t('order.productNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchParams.personNameLike" :placeholder="$t('order.userNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%" class="margin-top">
      <el-table-column prop="cartId" :label="$t('refundCart.orderNumber')" align="center"></el-table-column>
      <el-table-column prop="prodName" :label="$t('refundCart.productName')" align="center"></el-table-column>
      <el-table-column prop="specValue" :label="$t('refundCart.productSpec')" align="center"></el-table-column>
      <el-table-column prop="personName" :label="$t('refundCart.userName')" align="center"></el-table-column>
      <el-table-column prop="returnPayPrice" :label="$t('refundCart.refundAmount')" align="center"></el-table-column>
      <el-table-column prop="stateName" :label="$t('refundCart.orderStatus')" align="center"></el-table-column>
      <el-table-column prop="returnReason" :label="$t('refundCart.refundReason')" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('refundCart.applyTime')" align="center"></el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { queryAdminRefundOrders } from '@/api/admin/refundCartApi'

export default {
  name: 'AShopDetailRefundOrder',

  data() {
    return {
      searchParams: {
        prodNameLike: '',
        personNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          personNameLike: this.searchParams.personNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await queryAdminRefundOrders(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取退货订单列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.refund-order-container {
  padding: 20px;
}

.search-row {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}
</style>